import store from '@/store'

const isAuthenticatedGuard = async( to, from, next ) => {
    const idUsuario = store.state.idUsuario
    if (idUsuario > 0) next() 
    else next('/auth')
}

export default isAuthenticatedGuard
